module.exports = __webpack_public_path__ + "static/media/workshop_ys.a8c19850.jpg";